import React, {
  createContext,
  Dispatch,
  ReactNode,
  useContext,
  useReducer
} from 'react';
import { FilterActions, FilterState } from '../types/filters.type';
import { filterReducer } from '../reducers/filters.reducer';

export const FiltersContext = createContext<FilterState | null>(null);
export const FiltersDispatchContext =
  createContext<Dispatch<FilterActions> | null>(null);

export const FiltersProvider = ({ children }: { children: ReactNode }) => {
  const filtersInitialState = {
    filters: [],
    search: '',
    code: 'gerdau',
    sort: 'R'
  } as FilterState;

  const [filterState, dispatchFilter] = useReducer(
    filterReducer,
    filtersInitialState
  );

  return (
    <FiltersContext.Provider value={filterState}>
      <FiltersDispatchContext.Provider value={dispatchFilter}>
        {children}
      </FiltersDispatchContext.Provider>
    </FiltersContext.Provider>
  );
};

export function useFilters() {
  const context = useContext(FiltersContext);
  if (context === null) {
    throw new Error('Filter context should be provided');
  }
  return context;
}

export function useFiltersDispatch() {
  const context = useContext(FiltersDispatchContext);
  if (context === null) {
    throw new Error('Filter Dispatch context should be provided');
  }
  return context;
}
